import Scrollspy from "./scrollspy";
export const scrollspy = {
    init: () => {
        const scrollspyEle = document.querySelectorAll(".animate");
        [...scrollspyEle].forEach((el) => Scrollspy(el));
    },
};

export default scrollspy;